import React, { useState, useEffect } from 'react';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
import { TabBar, TabsMaster, SearchAdminProgramRequests } from '../../../components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UrlEnum } from '../../../shared';
import { academicProgramsService } from '../../../services';
import { RequestNav } from '../../../components/academic-affair-program-requests/components/program-requests-requestNav';
import { RequestDetails } from '../../../components/academic-affair-program-requests/components/program-requests-RequestDetails';
import { RequestLogHistory } from '../../../components/academic-affair-program-requests/components/admin/program-requests-RequestLogs';
import eventEmitter from "../../../shared/eventEmitter";

export const ProgramRequestAdminViewPage = props => {
    const [programRequestLogData, setProgramRequestLogData] = useState([]);
    const [requestNavData, setRequestNavData] = useState([]);
    const [currentRequestData, setCurrentRequestData] = useState([]);
    const [requestStatus, setRequestStatus] = useState('');
    const [requestId, setRequestId] = useState(-1);
    useEffect(() => {
        const parseQueryParams = () => {
            const query = props.location.state;
            if (query) {
                for (let param of query) {
                    setRequestNavData(param.otherRequests);
                    setCurrentRequestData(param.rowData);
                    setRequestId(param.requestID);
                }
            }
        };
        parseQueryParams();
    }, [props.location.state]);

    useEffect(() => {
        const handleDataUpdate = async () => {
            const res = academicProgramsService.getAllProgramRequests();
            console.log("logging for admin view page")
            Promise.resolve(res).then(data => {
                const navData = data.filter(x => x.statusId === currentRequestData.statusId);
                setRequestNavData(navData ?? []);
            });
        };
        eventEmitter.on('updateSARData', handleDataUpdate);
        return () => {
            eventEmitter.off('updateSARData', handleDataUpdate);
        };
    }, [currentRequestData]);

    useEffect(() => {
        if (requestId === -1 || requestNavData.length === 0) return;

        const res = academicProgramsService.getProgramRequestLogs(requestId);
        Promise.resolve(res).then(data => {
            setProgramRequestLogData(data ?? []);
        });

        let newData = requestNavData.find(x => x.requestID === requestId);
        if (newData === undefined) {
            newData = requestNavData[0];
            setRequestId(newData.requestID);
        } else {
            setCurrentRequestData(newData ?? []);
            setRequestStatus(newData.status ?? '');
        }
    }, [requestId, requestNavData]);
    return (
        <div className="program-request-details">
            <RequestNav
                requestNavData={requestNavData}
                currentRequestId={requestId}
                setCurrentRequestId={setRequestId}
            />
            {currentRequestData.typeId !== '7' && (
                <>
                    <RequestDetails
                        requestDetails={currentRequestData}
                        setRequestDetails={setCurrentRequestData}
                    />
                    <RequestLogHistory
                        requestLogs={programRequestLogData}
                        requestStatus={currentRequestData.status}
                        userInput={currentRequestData}
                    />
                </>
            )}
            {currentRequestData.typeId === '7' && (
                <>
                    <RequestDetails
                        requestDetails={currentRequestData}
                        setRequestDetails={setCurrentRequestData}
                    />
                    <RequestLogHistory
                        requestLogs={programRequestLogData}
                        requestStatus={currentRequestData.status}
                        userInput={currentRequestData}
                    />
                </>
            )}
        </div>
    );
};
